/**
 * i18n Configuration
 * Internationalization setup using i18next and react-i18next
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations
import enTranslation from './locales/en/translation.json';
import esTranslation from './locales/es/translation.json';
import hiTranslation from './locales/hi/translation.json';

// Define available languages
export const languages = {
  en: { nativeName: 'English', flag: '🇬🇧' },
  es: { nativeName: 'Español', flag: '🇪🇸' },
  hi: { nativeName: 'हिन्दी', flag: '🇮🇳' },
};

export const defaultLanguage = 'en';

// Initialize i18next
i18n
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    // Default language
    fallbackLng: defaultLanguage,

    // Available languages
    supportedLngs: Object.keys(languages),

    // Debug mode (disable in production)
    debug: import.meta.env.DEV,

    // Interpolation settings
    interpolation: {
      escapeValue: false, // React already safes from XSS
    },

    // Translation resources
    resources: {
      en: {
        translation: enTranslation,
      },
      es: {
        translation: esTranslation,
      },
      hi: {
        translation: hiTranslation,
      },
    },

    // Language detector options
    detection: {
      // Order of detection methods
      order: ['localStorage', 'navigator', 'htmlTag'],

      // Cache user language selection
      caches: ['localStorage'],

      // localStorage key
      lookupLocalStorage: 'i18nextLng',
    },

    // React-specific options
    react: {
      // Wait for translations to load before rendering
      useSuspense: true,
    },
  });

export default i18n;
